import { render, staticRenderFns } from "./GeneralLayout.vue?vue&type=template&id=be153340&scoped=true&lang=pug&"
import script from "./GeneralLayout.vue?vue&type=script&lang=js&"
export * from "./GeneralLayout.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLayout.vue?vue&type=style&index=0&id=be153340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be153340",
  null
  
)

export default component.exports